import { MENU_BALANCE_LOAD_SUCCESS, MENU_BALANCE_LOAD_URL } from 'moduleBase/modules/menu-balance/constants';

var menuBalanceLoadSuccess = function menuBalanceLoadSuccess(data) {
  return {
    type: MENU_BALANCE_LOAD_SUCCESS,
    payload: {
      menu: data.menu
    }
  };
};

var menuBalanceLoad = function menuBalanceLoad() {
  return function (dispatch, _, _ref) {
    var networkService = _ref.networkService;
    networkService.get(MENU_BALANCE_LOAD_URL).then(function (response) {
      dispatch(menuBalanceLoadSuccess(response.data));
    });
  };
};

export { menuBalanceLoad };